export default "/images/dcb2c200f3ac19c3474576f56a79d66b.avif";